export default (str: string | undefined) => {
  if (!str || typeof str !== 'string') {
    return '';
  }

  return str?.replaceAll(/[^a-zA-Z]/g, '').toLowerCase();
};
